<template>
  <v-tabs-items v-model="floor" vertical v-if="externalEventId">
    <exhibition-floor
      :booths="externalFloor.booths"
      v-for="externalFloor in externalFloors"
      :key="externalFloor.id"
    ></exhibition-floor>
  </v-tabs-items>
  <v-tabs-items v-model="floor" vertical v-else-if="pageType !== 'ICSMGE'">
    <exhibition-floor :booths="boothListEg"></exhibition-floor>
    <exhibition-floor :booths="boothListOg1"></exhibition-floor>
    <exhibition-floor :booths="boothListOg2"></exhibition-floor>
  </v-tabs-items>
  <v-tabs-items v-model="floor" vertical v-else>
    <exhibition-floor :booths="booths"></exhibition-floor>
  </v-tabs-items>
</template>

<script>
import ExhibitionFloor from "./ExhibitionFloor/ExhibitionFloorList";
import { mapGetters } from "vuex";
export default {
  props: ["floor"],

  components: {
    ExhibitionFloor,
  },
  computed: {
    ...mapGetters([
      "boothListEg",
      "boothListOg1",
      "boothListOg2",
      "booths",
      "pageType",
      "externalEventId",
      "externalFloors",
    ]),
  },
};
</script>

<style></style>
